import { FC } from 'react';
import { AnimatedShape, Box, Card, useThemeValue } from '@altermaind/web/ui';
import { convertSizeToNumber } from '@/_shared/helpers/convertSizeToNumber';

export const CardsIncompleteDataSkeleton: FC = () => {
  const gapS = convertSizeToNumber(`${useThemeValue('sizes', 's')}`);
  const skeletonItems = Array.from({ length: 3 });

  return (
    <Box display='flex' flexDirection='column' flex={1} style={{ gap: gapS }}>
      {skeletonItems.map(() => (
        <Card
          width='100%'
          height='100%'
          display='flex'
          flex={1}
          p='s'
          flexDirection='row'
          borderWidth={1}
          borderStyle='solid'
          borderColor='primary/text'
          key={`skeleton_item_${Math.random()}`}
        >
          <Box display='flex' flexDirection='row' flex={0} mr='s'>
            <AnimatedShape size='m' variant='round' />
          </Box>
          <Box display='flex' flexDirection='column' flex={1} justifyContent='flex-start'>
            <AnimatedShape height={25} width='60%' variant='semiRound' />
            <Box display='flex' flex={1} mt='xs'>
              <AnimatedShape height={15} width='25%' variant='semiRound' />
            </Box>
          </Box>
          <Box display='flex' flexDirection='row' flex={0} ml='s'>
            <AnimatedShape size='s' />
          </Box>
        </Card>
      ))}
    </Box>
  );
};
